import { TranslationLocale } from '@/store/use-translation-store';

const basic_zh_CN = {
  // 运动翻译
  'outdoor_sports.sport': '户外跑步',
  'walk_outdoor.sport': '健走',
  'run_indoor.sport': '室内跑步',
  'climbing.sport': '登山',
  'cross_country.sport': '越野',
  'ride_outdoor.sport': '户外骑行',
  'ride_indoor.sport': '室内单车',
  'free_training.sport': '自由训练',
  'swim_indoor.sport': '泳池游泳',
  'swim_outdoor.sport': '开放水域游泳',
  'elliptical_machine.sport': '椭圆机',
  'yoga.sport': '瑜伽',
  'rowing_machine.sport': '划船机',
  'rope_skipping.sport': '跳绳',
  'hiking_outdoor.sport': '徒步',
  'high_interval_training.sport': '高强度间歇训练',
  'triathlon.sport': '铁人三项',
  'sailboat.sport': '帆船',
  'paddle_board.sport': '桨板',
  'water_polo.sport': '水球',
  'water_sports.sport': '水上运动',
  'surfing.sport': '滑水',
  'canoeing.sport': '皮划艇',
  'kayak_rafting.sport': '皮艇漂流',
  'rowing.sport': '划船',
  'motorboat.sport': '摩托艇',
  'web_swimming.sport': '蹼泳',
  'driving.sport': '跳水',
  'fancy_swimming.sport': '花样游泳',
  'snorkeling.sport': '浮潜',
  'kite_surfing.sport': '风筝冲浪',
  'indoor_surfing.sport': '室内冲浪',
  'dragon_boat.sport': '龙舟',
  'diving.sport': '潜水',
  'free_diving.sport': '自由潜水',
  'scuba_diving.sport': '休闲水肺潜水',
  'instrument_diving.sport': '仪表潜水',
  'rock_climbing.sport': '攀岩',
  'skate.sport': '滑板',
  'roller_skating.sport': '轮滑',
  'parkour.sport': '跑酷',
  'atv.sport': '沙滩车',
  'paraglider.sport': '滑翔伞',
  'bicycle_moto.sport': '小轮车',
  'hell_and_toe.sport': '竞走',
  'climbing_machine.sport': '爬楼机',
  'climb_stairs.sport': '爬楼梯',
  'stepper.sport': '踏步机',
  'core_training.sport': '核心训练',
  'flexibility_training.sport': '柔韧训练',
  'pilates.sport': '普拉提',
  'gymnastics.sport': '体操',
  'stretch.sport': '拉伸',
  'strength_training.sport': '力量训练',
  'crossfit.sport': '交叉训练',
  'aerobics.sport': '健身操',
  'physical_training.sport': '体能训练',
  'wall_ball.sport': '墙球',
  'dumbbell_training.sport': '哑铃训练',
  'barbell_training.sport': '杠铃训练',
  'weightlifting.sport': '举重',
  'deadlift.sport': '硬拉',
  'bobby_jump.sport': '波比跳',
  'sit_ups.sport': '仰卧起坐',
  'functional_training.sport': '功能性训练',
  'upper_limb_training.sport': '上肢训练',
  'lower_limb_training.sport': '下肢训练',
  'waist_training.sport': '腰腹训练',
  'back_training.sport': '背部训练',
  'spinning.sport': '动感单车',
  'walking_machine.sport': '漫步机',
  'step_training.sport': '踏步训练',
  'single_bar.sport': '单杠',
  'parallel_bars.sport': '双杠',
  'group_callisthenics.sport': '团体操',
  'strike.sport': '搏击操',
  'battle_rope.sport': '战绳',
  'mixed_aerobic.sport': '混合有氧',
  'walk_indoor.sport': '室内步行',
  'indoor_gym.sport': '健身房训练',
  'square_dance.sport': '广场舞',
  'belly_dance.sport': '肚皮舞',
  'ballet.sport': '芭蕾舞',
  'street_dance.sport': '街舞',
  'zumba.sport': '尊巴',
  'national_dance.sport': '民族舞',
  'jazz.sport': '爵士舞',
  'latin_dance.sport': '拉丁舞',
  'hip_hop_dance.sport': '嘻哈舞',
  'pole_dance.sport': '钢管舞',
  'breakdancing.sport': '霹雳舞',
  'social_dancing.sport': '交际舞',
  'modern_dancing.sport': '现代舞',
  'dance.sport': '舞蹈',
  'boxing.sport': '拳击',
  'wrestling.sport': '摔跤',
  'martial_arts.sport': '武术',
  'taichi.sport': '太极',
  'muay_thai.sport': '泰拳',
  'judo.sport': '柔道',
  'taekwondo.sport': '跆拳道',
  'karate.sport': '空手道',
  'free_sparring.sport': '自由搏击',
  'swordsmanship.sport': '剑术/剑道',
  'fencing.sport': '击剑',
  'jujitsu.sport': '柔术',
  'football.sport': '足球',
  'basketball.sport': '篮球',
  'volleyball.sport': '排球',
  'baseball.sport': '棒球',
  'softball.sport': '垒球',
  'rugby.sport': '橄榄球',
  'hockey.sport': '曲棍球',
  'pingpong.sport': '乒乓球',
  'badminton.sport': '羽毛球',
  'tennis.sport': '网球',
  'cricket.sport': '板球',
  'handball.sport': '手球',
  'bowling.sport': '保龄球',
  'squash.sport': '壁球',
  'billiards.sport': '台球',
  'shuttlecock.sport': '毽球',
  'beach_football.sport': '沙滩足球',
  'beach_volleyball.sport': '沙滩排球',
  'sepak_takraw.sport': '藤球',
  'golf.sport': '高尔夫球',
  'foosball.sport': '桌上足球',
  'indoor_football.sport': '室内足球',
  'sandbags_ball.sport': '沙包球',
  'bocci.sport': '地掷球',
  'hihi_ball.sport': '回力球',
  'gateball.sport': '门球',
  'dodgeball.sport': '躲避球',
  'shuffleboard.sport': '砂壶球',
  'outdoor_skating.sport': '户外滑冰',
  'curling.sport': '冰壶',
  'snow_sports.sport': '雪上运动',
  'snowmobile.sport': '雪地摩托',
  'puck.sport': '冰球',
  'snow_car.sport': '雪车',
  'sled.sport': '雪橇',
  'indoor_skating.sport': '室内滑冰',
  'snowboarding.sport': '单板滑雪',
  'double_board_skiing.sport': '双板滑雪',
  'cross_country_skiing.sport': '越野滑雪',
  'archery.sport': '射箭',
  'darts.sport': '飞镖',
  'horse_riding.sport': '骑马',
  'tug_of_war.sport': '拔河',
  'hula_hoop.sport': '呼啦圈',
  'fly_kite.sport': '放风筝',
  'fishing.sport': '钓鱼',
  'frisbee.sport': '飞盘',
  'shuttlecock_kicking.sport': '踢毽子',
  'swing.sport': '秋千',
  'motion_sensing_game.sport': '体感游戏',
  'electronic_sports.sport': '电子竞技',
  'chess.sport': '国际象棋',
  'draughts.sport': '国际跳棋',
  'weiqi.sport': '围棋',
  'bridge.sport': '桥牌',
  'board_games.sport': '桌游',
  'indoor_rock.sport': '室内攀岩',
  'outdoor_rock.sport': '户外攀岩',
  'equesttrian.sport': '马术',
  'track_and_field.sport': '田径',
  'racing_car.sport': '赛车',
  'track_running.sport': '操场跑步'
};
export type JumpSportTranslationKey = keyof typeof basic_zh_CN;

export const jumpSportTranslations: {
  [key in TranslationLocale]: Partial<Record<JumpSportTranslationKey, string>>;
} = {
  zh_CN: { ...basic_zh_CN },
  en_US: {
    // 运动翻译
    'outdoor_sports.sport': 'Outdoor running',
    'walk_outdoor.sport': 'Walking',
    'run_indoor.sport': 'Treadmill',
    'climbing.sport': 'Trekking',
    'cross_country.sport': 'Trail run',
    'ride_outdoor.sport': 'Outdoor cycling',
    'ride_indoor.sport': 'Indoor cycling',
    'free_training.sport': 'Free training',
    'swim_indoor.sport': 'Pool swimming',
    'swim_outdoor.sport': 'Open water',
    'elliptical_machine.sport': 'Elliptical',
    'yoga.sport': 'Yoga',
    'rowing_machine.sport': 'Rower',
    'rope_skipping.sport': 'Jump rope',
    'hiking_outdoor.sport': 'Hiking',
    'high_interval_training.sport': 'HIIT',
    'triathlon.sport': 'Triathlon',
    'sailboat.sport': 'Sailing',
    'paddle_board.sport': 'Paddleboarding',
    'water_polo.sport': 'Water polo',
    'water_sports.sport': 'Water sports',
    'surfing.sport': 'Water skiing',
    'canoeing.sport': 'Kayaking',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Rowing',
    'motorboat.sport': 'Powerboating',
    'web_swimming.sport': 'Finswimming',
    'driving.sport': 'Diving',
    'fancy_swimming.sport': 'Artistic swimming',
    'snorkeling.sport': 'Snorkeling',
    'kite_surfing.sport': 'Kitesurfing',
    'indoor_surfing.sport': 'Flowriding',
    'dragon_boat.sport': 'Dragon boat',
    'diving.sport': 'Diving',
    'free_diving.sport': 'Free diving',
    'scuba_diving.sport': 'Recreational scuba diving',
    'instrument_diving.sport': 'Basic mode',
    'rock_climbing.sport': 'Rock climbing',
    'skate.sport': 'Skateboarding',
    'roller_skating.sport': 'Roller skating',
    'parkour.sport': 'Parkour',
    'atv.sport': 'ATV',
    'paraglider.sport': 'Paragliding',
    'bicycle_moto.sport': 'BMX',
    'hell_and_toe.sport': 'Race walk',
    'climbing_machine.sport': 'Stair climber',
    'climb_stairs.sport': 'Stair climbing',
    'stepper.sport': 'Stepper',
    'core_training.sport': 'Core training',
    'flexibility_training.sport': 'Flexibility',
    'pilates.sport': 'Pilates',
    'gymnastics.sport': 'Gymnastics',
    'stretch.sport': 'Stretching',
    'strength_training.sport': 'Strength',
    'crossfit.sport': 'Crossfit',
    'aerobics.sport': 'Aerobics',
    'physical_training.sport': 'Physical training',
    'wall_ball.sport': 'Wall ball',
    'dumbbell_training.sport': 'Dumbbell',
    'barbell_training.sport': 'Barbell',
    'weightlifting.sport': 'Weightlifting',
    'deadlift.sport': 'Deadlift',
    'bobby_jump.sport': 'Burpee',
    'sit_ups.sport': 'Sit-ups',
    'functional_training.sport': 'Functional training',
    'upper_limb_training.sport': 'Upper body',
    'lower_limb_training.sport': 'Lower body',
    'waist_training.sport': 'Abs',
    'back_training.sport': 'Back',
    'spinning.sport': 'Spinning',
    'walking_machine.sport': 'Air walker',
    'step_training.sport': 'Stepper',
    'single_bar.sport': 'Horizontal bar',
    'parallel_bars.sport': 'Parallel bars',
    'group_callisthenics.sport': 'Mass gymnastics',
    'strike.sport': 'Cardio combat',
    'battle_rope.sport': 'Battle rope',
    'mixed_aerobic.sport': 'Aerobic combo',
    'walk_indoor.sport': 'Indoor walking',
    'indoor_gym.sport': 'Indoor fitness',
    'square_dance.sport': 'Square dancing',
    'belly_dance.sport': 'Belly dance',
    'ballet.sport': 'Ballet',
    'street_dance.sport': 'Street dance',
    'zumba.sport': 'Zumba',
    'national_dance.sport': 'Folk dance',
    'jazz.sport': 'Jazz dance',
    'latin_dance.sport': 'Latin dance',
    'hip_hop_dance.sport': 'Hip hop',
    'pole_dance.sport': 'Pole dance',
    'breakdancing.sport': 'Breaking',
    'social_dancing.sport': 'Ballroom dance',
    'modern_dancing.sport': 'Modern dance',
    'dance.sport': 'Dance',
    'boxing.sport': 'Boxing',
    'wrestling.sport': 'Wrestling',
    'martial_arts.sport': 'Martial arts',
    'taichi.sport': 'Tai chi',
    'muay_thai.sport': 'Muay Thai',
    'judo.sport': 'Judo',
    'taekwondo.sport': 'Taekwondo',
    'karate.sport': 'Karate',
    'free_sparring.sport': 'Kickboxing',
    'swordsmanship.sport': 'Kendo',
    'fencing.sport': 'Fencing',
    'jujitsu.sport': 'Jujitsu',
    'football.sport': 'Soccer',
    'basketball.sport': 'Basketball',
    'volleyball.sport': 'Volleyball',
    'baseball.sport': 'Baseball',
    'softball.sport': 'Softball',
    'rugby.sport': 'American football',
    'hockey.sport': 'Hockey',
    'pingpong.sport': 'Table tennis',
    'badminton.sport': 'Badminton',
    'tennis.sport': 'Tennis',
    'cricket.sport': 'Cricket',
    'handball.sport': 'Handball',
    'bowling.sport': 'Bowling',
    'squash.sport': 'Squash',
    'billiards.sport': 'Billiards',
    'shuttlecock.sport': 'Shuttlecock',
    'beach_football.sport': 'Beach soccer',
    'beach_volleyball.sport': 'Beach volleyball',
    'sepak_takraw.sport': 'Sepak takraw',
    'golf.sport': 'Golf',
    'foosball.sport': 'Table football',
    'indoor_football.sport': 'Futsal',
    'sandbags_ball.sport': 'Hacky sack',
    'bocci.sport': 'Bocce',
    'hihi_ball.sport': 'Jai alai',
    'gateball.sport': 'Gateball',
    'dodgeball.sport': 'Dodgeball',
    'shuffleboard.sport': 'Shuffleboard',
    'outdoor_skating.sport': 'Ice skating',
    'curling.sport': 'Curling',
    'snow_sports.sport': 'Other winter sports',
    'snowmobile.sport': 'Snowmobile',
    'puck.sport': 'Ice hockey',
    'snow_car.sport': 'Bobsleigh',
    'sled.sport': 'Sledding',
    'indoor_skating.sport': 'Indoor ice skating',
    'snowboarding.sport': 'Snowboarding',
    'double_board_skiing.sport': 'Skiing',
    'cross_country_skiing.sport': 'Cross-country skiing',
    'archery.sport': 'Archery',
    'darts.sport': 'Darts',
    'horse_riding.sport': 'Horse riding',
    'tug_of_war.sport': 'Tug of war',
    'hula_hoop.sport': 'Hula hoop',
    'fly_kite.sport': 'Kite flying',
    'fishing.sport': 'Fishing',
    'frisbee.sport': 'Frisbee',
    'shuttlecock_kicking.sport': 'Shuttlecock',
    'swing.sport': 'Swinging',
    'motion_sensing_game.sport': 'Somatosensory game',
    'electronic_sports.sport': 'Esports',
    'chess.sport': 'Chess',
    'draughts.sport': 'Checkers',
    'weiqi.sport': 'Weiqi',
    'bridge.sport': 'Bridge',
    'board_games.sport': 'Board game',
    'indoor_rock.sport': 'Indoor rock climbing',
    'outdoor_rock.sport': 'Outdoor rock climbing',
    'equesttrian.sport': 'Equestrian',
    'track_and_field.sport': 'Athletics',
    'racing_car.sport': 'Auto racing',
    'track_running.sport': 'Track running'
  },
  zh_TW: {
    'ride_outdoor.sport': '戶外騎行',
    'outdoor_sports.sport': '戶外跑步',
    'cross_country.sport': '越野',
    'swim_indoor.sport': '泳池游泳',
    'hiking_outdoor.sport': '徒步',
    'double_board_skiing.sport': '雙板滑雪',
    'run_indoor.sport': '室內跑步',
    'climbing.sport': '登山',
    'walk_outdoor.sport': '健走',
    'snowboarding.sport': '單板滑雪',
    'swim_outdoor.sport': '開放水域游泳',
    'fishing.sport': '釣魚',
    'sailboat.sport': '帆船',
    'paddle_board.sport': '槳板',
    'water_polo.sport': '水球',
    'water_sports.sport': '水上運動',
    'surfing.sport': '滑水',
    'canoeing.sport': '皮划艇',
    'kayak_rafting.sport': '皮艇漂流',
    'rowing.sport': '划船',
    'motorboat.sport': '水上摩托車',
    'web_swimming.sport': '蹼泳',
    'track_running.sport': '操場跑步'
  },
  ja_JP: {
    'ride_outdoor.sport': ' 屋外サイクリング ',
    'outdoor_sports.sport': ' 屋外ランニング ',
    'cross_country.sport': ' トレイルラン ',
    'swim_indoor.sport': ' プールスイミング ',
    'hiking_outdoor.sport': ' ハイキング ',
    'double_board_skiing.sport': ' スキー ',
    'run_indoor.sport': ' トレッドミル ',
    'climbing.sport': ' トレッキング ',
    'walk_outdoor.sport': ' ウォーキング ',
    'snowboarding.sport': ' スノーボード ',
    'swim_outdoor.sport': ' オープンウォーター ',
    'fishing.sport': ' 釣り ',
    'sailboat.sport': ' セーリング ',
    'paddle_board.sport': ' パドルボード ',
    'water_polo.sport': ' 水球 ',
    'water_sports.sport': ' ウォータースポーツ ',
    'surfing.sport': ' 水上スキー ',
    'canoeing.sport': ' カヤック ',
    'kayak_rafting.sport': ' ラフティング ',
    'rowing.sport': ' ローイング ',
    'motorboat.sport': ' パワーボート ',
    'web_swimming.sport': ' フィンスイミング '
  },
  es_ES: {
    'ride_outdoor.sport': 'Ciclismo al aire libre',
    'outdoor_sports.sport': 'Correr al aire libre',
    'cross_country.sport': 'Carrera en pista',
    'swim_indoor.sport': 'Natación en piscina',
    'hiking_outdoor.sport': 'Senderismo',
    'double_board_skiing.sport': 'Esquí',
    'run_indoor.sport': 'Correr en cinta',
    'climbing.sport': 'Excursionismo',
    'walk_outdoor.sport': 'Caminar',
    'snowboarding.sport': 'Snowboard',
    'swim_outdoor.sport': 'Aguas abiertas',
    'fishing.sport': 'Pesca',
    'sailboat.sport': 'Vela',
    'paddle_board.sport': 'Paddle surf',
    'water_polo.sport': 'Waterpolo',
    'water_sports.sport': 'Deportes acuáticos',
    'surfing.sport': 'Esquí acuático',
    'canoeing.sport': 'Kayak',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Remo',
    'motorboat.sport': 'Motonáutica',
    'web_swimming.sport': 'Natación con aletas'
  },
  fr_FR: {
    'ride_outdoor.sport': 'Cyclisme en plein air',
    'outdoor_sports.sport': 'Course en extérieur',
    'cross_country.sport': 'Course sur sentier',
    'swim_indoor.sport': 'Natation en piscine',
    'hiking_outdoor.sport': 'Randonnée',
    'double_board_skiing.sport': 'Ski',
    'run_indoor.sport': 'Tapis de course',
    'climbing.sport': 'Cheminer',
    'walk_outdoor.sport': 'Marche',
    'snowboarding.sport': 'Snowboard',
    'swim_outdoor.sport': 'Eau libre',
    'fishing.sport': 'Pêche',
    'sailboat.sport': 'Voile',
    'paddle_board.sport': 'Planche à rame',
    'water_polo.sport': 'Water polo',
    'water_sports.sport': 'Sports nautiques',
    'surfing.sport': 'Ski nautique',
    'canoeing.sport': 'Le kayak',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': "L'aviron",
    'motorboat.sport': 'Motonautisme',
    'web_swimming.sport': 'Nage avec palmes'
  },
  de_DE: {
    'ride_outdoor.sport': 'Radfahren im Freien',
    'outdoor_sports.sport': 'Laufen im Freien',
    'cross_country.sport': 'Trail-Lauf',
    'swim_indoor.sport': 'Beckenschwimmen',
    'hiking_outdoor.sport': 'Wandern',
    'double_board_skiing.sport': 'Skifahren',
    'run_indoor.sport': 'Laufband',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Gehen',
    'snowboarding.sport': 'Snowboarden',
    'swim_outdoor.sport': 'Offenes Gewässer',
    'fishing.sport': 'Angeln',
    'sailboat.sport': 'Segeln',
    'paddle_board.sport': 'Paddelboarden',
    'water_polo.sport': 'Wasserball',
    'water_sports.sport': 'Wassersport',
    'surfing.sport': 'Wasserski',
    'canoeing.sport': 'Kajakfahren',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Rudern',
    'motorboat.sport': 'Motorbootsport',
    'web_swimming.sport': 'Flossenschwimmen'
  },
  ru_RU: {
    'ride_outdoor.sport': 'Езда на велосипеде на улице',
    'outdoor_sports.sport': 'Бег на улице',
    'cross_country.sport': 'Трейлраннинг',
    'swim_indoor.sport': 'Бассейн',
    'hiking_outdoor.sport': 'Хайкинг',
    'double_board_skiing.sport': 'Лыжи',
    'run_indoor.sport': 'Беговая дорожка',
    'climbing.sport': 'Треккинг',
    'walk_outdoor.sport': 'Ходьба',
    'snowboarding.sport': 'Сноуборд',
    'swim_outdoor.sport': 'Водоем',
    'fishing.sport': 'Рыбалка',
    'sailboat.sport': 'Парусный спорт',
    'paddle_board.sport': 'Сапсерфинг',
    'water_polo.sport': 'Водное поло',
    'water_sports.sport': 'Водные виды спорта',
    'surfing.sport': 'Водные лыжи',
    'canoeing.sport': 'Каякинг',
    'kayak_rafting.sport': 'Рафтинг',
    'rowing.sport': 'Гребля',
    'motorboat.sport': 'Водно-моторный спорт',
    'web_swimming.sport': 'Скоростное плавание в ластах'
  },
  pt_BR: {
    'ride_outdoor.sport': 'Ciclismo ao ar livre',
    'outdoor_sports.sport': 'Corrida ao ar livre',
    'cross_country.sport': 'Corrida em trilha',
    'swim_indoor.sport': 'Natação em piscina',
    'hiking_outdoor.sport': 'Escalada',
    'double_board_skiing.sport': 'Esqui',
    'run_indoor.sport': 'Esteira',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Caminhada',
    'snowboarding.sport': 'Snowboarding',
    'swim_outdoor.sport': 'Natação em águas abertas',
    'fishing.sport': 'Pescaria',
    'sailboat.sport': 'Vela',
    'paddle_board.sport': 'Stand Up Paddle',
    'water_polo.sport': 'Polo aquático',
    'water_sports.sport': 'Esportes aquáticos',
    'surfing.sport': 'Esqui aquático',
    'canoeing.sport': 'Caiaque',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Remo',
    'motorboat.sport': 'Motonáutica',
    'web_swimming.sport': 'Natação com nadadeiras'
  },
  pt_PT: {
    'ride_outdoor.sport': 'Ciclismo ao ar livre',
    'outdoor_sports.sport': 'Corrida ao ar livre',
    'cross_country.sport': 'Corrida em trilha',
    'swim_indoor.sport': 'Natação em piscina',
    'hiking_outdoor.sport': 'Caminhada',
    'double_board_skiing.sport': 'Esqui',
    'run_indoor.sport': 'Passadeira',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Caminhada',
    'snowboarding.sport': 'Snowboarding',
    'swim_outdoor.sport': 'Natação de águas abertas',
    'fishing.sport': 'Pescaria',
    'sailboat.sport': 'Vela',
    'paddle_board.sport': 'Stand Up Paddle',
    'water_polo.sport': 'Polo aquático',
    'water_sports.sport': 'Desportos aquáticos',
    'surfing.sport': 'Esqui aquático',
    'canoeing.sport': 'Caiaque',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Remo',
    'motorboat.sport': 'Motonáutica',
    'web_swimming.sport': 'Natação com barbatanas'
  },
  it_IT: {
    'ride_outdoor.sport': "Ciclismo all'aperto",
    'outdoor_sports.sport': "Corsa all'aperto",
    'cross_country.sport': 'Corsa trail',
    'swim_indoor.sport': 'Nuoto in piscina',
    'hiking_outdoor.sport': 'Escursionismo',
    'double_board_skiing.sport': 'Sci',
    'run_indoor.sport': 'Tapis roulant',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Camminata',
    'snowboarding.sport': 'Snowboard',
    'swim_outdoor.sport': 'Nuoto libero',
    'fishing.sport': 'Pesca',
    'sailboat.sport': 'Vela',
    'paddle_board.sport': 'Paddleboarding',
    'water_polo.sport': 'Pallanuoto',
    'water_sports.sport': 'Sport acquatici',
    'surfing.sport': 'Sci nautico',
    'canoeing.sport': 'Kayaking',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Canottaggio',
    'motorboat.sport': 'Motonautica',
    'web_swimming.sport': 'Nuoto pinnato'
  },
  ko_KR: {
    'ride_outdoor.sport': '야외 사이클링',
    'outdoor_sports.sport': '야외 달리기',
    'cross_country.sport': '트레일 런',
    'swim_indoor.sport': '실내 수영',
    'hiking_outdoor.sport': '하이킹',
    'double_board_skiing.sport': '스키',
    'run_indoor.sport': '트레드밀',
    'climbing.sport': '트레킹',
    'walk_outdoor.sport': '걷기',
    'snowboarding.sport': '스노우보드',
    'swim_outdoor.sport': '야외 수영',
    'fishing.sport': '낚시',
    'sailboat.sport': '세일링',
    'paddle_board.sport': '패들보딩',
    'water_polo.sport': '수구',
    'water_sports.sport': '수상 운동',
    'surfing.sport': '수상 스키',
    'canoeing.sport': '카약',
    'kayak_rafting.sport': '래프팅',
    'rowing.sport': '로잉',
    'motorboat.sport': '모터보트',
    'web_swimming.sport': '핀수영'
  },
  tr_TR: {
    'ride_outdoor.sport': 'Açık hava bisikleti',
    'outdoor_sports.sport': 'Açık hava koşusu',
    'cross_country.sport': 'Patika koşusu',
    'swim_indoor.sport': 'Havuzda yüzme',
    'hiking_outdoor.sport': 'Doğa yürüyüşü',
    'double_board_skiing.sport': 'Kayak',
    'run_indoor.sport': 'Koşu bandı',
    'climbing.sport': 'Doğa yürüyüşü',
    'walk_outdoor.sport': 'Yürüyüş',
    'snowboarding.sport': 'Snowboard',
    'swim_outdoor.sport': 'Açık su',
    'fishing.sport': 'Balık tutma',
    'sailboat.sport': 'Yelken',
    'paddle_board.sport': 'Kürek sörfü',
    'water_polo.sport': 'Su topu',
    'water_sports.sport': 'Diğer su sporları',
    'surfing.sport': 'Su kayağı',
    'canoeing.sport': 'Kano sporu',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Kürek çekme',
    'motorboat.sport': 'Sürat teknesi',
    'web_swimming.sport': 'Paletli yüzme'
  },
  nl_NL: {
    'ride_outdoor.sport': 'Buiten fietsen',
    'outdoor_sports.sport': 'Buiten hardlopen',
    'cross_country.sport': 'Trailrunning',
    'swim_indoor.sport': 'Zwembad zwemmen',
    'hiking_outdoor.sport': 'Wandelen',
    'double_board_skiing.sport': 'Skiën',
    'run_indoor.sport': 'Loopband',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Lopen',
    'snowboarding.sport': 'Snowboarden',
    'swim_outdoor.sport': 'Open water',
    'fishing.sport': 'Vissen',
    'sailboat.sport': 'Zeilen',
    'paddle_board.sport': 'Paddle boarding',
    'water_polo.sport': 'Waterpolo',
    'water_sports.sport': 'Watersport',
    'surfing.sport': 'Waterskiën',
    'canoeing.sport': 'Kajakken',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Roeien',
    'motorboat.sport': 'Motorboten',
    'web_swimming.sport': 'Vinnen zwemmen'
  },
  th_TH: {
    'ride_outdoor.sport': 'ปั่นจักรยานกลางแจ้ง',
    'outdoor_sports.sport': 'วิ่งกลางแจ้ง',
    'cross_country.sport': 'วิ่งเทรล',
    'swim_indoor.sport': 'ว่ายน้ำในสระ',
    'hiking_outdoor.sport': 'เดินป่า',
    'double_board_skiing.sport': 'สกี',
    'run_indoor.sport': 'ลู่วิ่ง',
    'climbing.sport': 'เดินเขา',
    'walk_outdoor.sport': 'เดิน',
    'snowboarding.sport': 'สโนว์บอร์ด',
    'swim_outdoor.sport': 'ว่ายน้ำข้างนอก',
    'fishing.sport': 'ตกปลา',
    'sailboat.sport': 'แล่นเรือ',
    'paddle_board.sport': 'แพดเดิลบอร์ด',
    'water_polo.sport': 'โปโลน้ำ',
    'water_sports.sport': 'กีฬาทางน้ำอื่นๆ',
    'surfing.sport': 'สกีน้ำ',
    'canoeing.sport': 'พายเรือคายัค',
    'kayak_rafting.sport': 'ล่องแพ',
    'rowing.sport': 'พายเรือ',
    'motorboat.sport': 'เรือยนต์',
    'web_swimming.sport': 'ฟินสวิมมิ่ง'
  },
  sv_SE: {
    'ride_outdoor.sport': 'Cykling utomhus',
    'outdoor_sports.sport': 'Löpning utomhus',
    'cross_country.sport': 'Terränglöpning',
    'swim_indoor.sport': 'Simma i pool',
    'hiking_outdoor.sport': 'Vandring',
    'double_board_skiing.sport': 'Skidåkning',
    'run_indoor.sport': 'Löpband',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Gång',
    'snowboarding.sport': 'Snowboardåkning',
    'swim_outdoor.sport': 'Öppet vatten',
    'fishing.sport': 'Fiske',
    'sailboat.sport': 'Segling',
    'paddle_board.sport': 'Paddelsurfing',
    'water_polo.sport': 'Vattenpolo',
    'water_sports.sport': 'Övriga vattensporter',
    'surfing.sport': 'Vattenskidåkning',
    'canoeing.sport': 'Kajakpaddling',
    'kayak_rafting.sport': 'Forsränning',
    'rowing.sport': 'Rodd',
    'motorboat.sport': 'Motorbåtsport',
    'web_swimming.sport': 'Fensimning'
  },
  da_DK: {
    'ride_outdoor.sport': 'Udendørs cykling',
    'outdoor_sports.sport': 'Udendørs løb',
    'cross_country.sport': 'Trailløb',
    'swim_indoor.sport': 'Svømning i pool',
    'hiking_outdoor.sport': 'Vandring',
    'double_board_skiing.sport': 'Skiløb',
    'run_indoor.sport': 'Løbebånd',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Gang',
    'snowboarding.sport': 'Snowboarding',
    'swim_outdoor.sport': 'Åbent vand',
    'fishing.sport': 'Lystfiskeri',
    'sailboat.sport': 'Sejlads',
    'paddle_board.sport': 'Stand Up Paddle (SUP)',
    'water_polo.sport': 'Vandpolo',
    'water_sports.sport': 'Vandsport',
    'surfing.sport': 'Vandski',
    'canoeing.sport': 'Kajak-roning',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Roning',
    'motorboat.sport': 'Motorbådssport',
    'web_swimming.sport': 'Finnesvømning'
  },
  vi_VN: {
    'ride_outdoor.sport': 'Đạp xe ngoài trời',
    'outdoor_sports.sport': 'Chạy bộ ngoài trời',
    'cross_country.sport': 'Chạy việt dã',
    'swim_indoor.sport': 'Bơi trong hồ bơi',
    'hiking_outdoor.sport': 'Đi bộ đường dài',
    'double_board_skiing.sport': 'Trượt tuyết',
    'run_indoor.sport': 'Máy chạy bộ',
    'climbing.sport': 'Đi bộ dài ngày',
    'walk_outdoor.sport': 'Đi bộ',
    'snowboarding.sport': 'Trượt ván trên tuyết',
    'swim_outdoor.sport': 'Bơi ngoài trời',
    'fishing.sport': 'Câu cá',
    'sailboat.sport': 'Đua thuyền buồm',
    'paddle_board.sport': 'Chèo ván đứng',
    'water_polo.sport': 'Bóng nước',
    'water_sports.sport': 'Thể thao dưới nước khác',
    'surfing.sport': 'Lướt ván nước',
    'canoeing.sport': 'Chèo thuyền kayak',
    'kayak_rafting.sport': 'Chèo thuyền vượt thác',
    'rowing.sport': 'Chèo thuyền',
    'motorboat.sport': 'Chèo thuyền máy',
    'web_swimming.sport': 'Bơi lặn'
  },
  nb_NO: {
    'ride_outdoor.sport': 'Sykling utendørs',
    'outdoor_sports.sport': 'Buiten hardlopen',
    'cross_country.sport': 'Terrengløp',
    'swim_indoor.sport': 'Svømming i basseng',
    'hiking_outdoor.sport': 'Vandring',
    'double_board_skiing.sport': 'Skiløp',
    'run_indoor.sport': 'Tredemølle',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Gåtur',
    'snowboarding.sport': 'Snowboardkjøring',
    'swim_outdoor.sport': 'Åpent vann',
    'fishing.sport': 'Fiske',
    'sailboat.sport': 'Seiling',
    'paddle_board.sport': 'Padlebrett',
    'water_polo.sport': 'Vannpolo',
    'water_sports.sport': 'Vannsport',
    'surfing.sport': 'Vannski',
    'canoeing.sport': 'Kajakkpadling',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Roing',
    'motorboat.sport': 'Motorbåtkjøring',
    'web_swimming.sport': 'Finnesvømming'
  },
  pl_PL: {
    'ride_outdoor.sport': 'Jazda na rowerze',
    'outdoor_sports.sport': 'Bieganie',
    'cross_country.sport': 'Bieg terenowy',
    'swim_indoor.sport': 'Pływanie w basenie',
    'hiking_outdoor.sport': 'Wspinaczka',
    'double_board_skiing.sport': 'Jazda na nartach',
    'run_indoor.sport': 'Bieżnia',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Chodzenie',
    'snowboarding.sport': 'Jazda na snowboardzie',
    'swim_outdoor.sport': 'Trening open water',
    'fishing.sport': 'Łowienie ryb',
    'sailboat.sport': 'Żeglarstwo',
    'paddle_board.sport': 'SUP',
    'water_polo.sport': 'Wodne polo',
    'water_sports.sport': 'Sporty wodne',
    'surfing.sport': 'Narciarstwo wodne',
    'canoeing.sport': 'Spływy kajakowe',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Wioślarstwo',
    'motorboat.sport': 'Motorówka',
    'web_swimming.sport': 'Pływanie w płetwach'
  },
  fi_FI: {
    'ride_outdoor.sport': 'Ulkopyöräily',
    'outdoor_sports.sport': 'Ulkona juoksu',
    'cross_country.sport': 'Polkujuoksu',
    'swim_indoor.sport': 'Allasuinti',
    'hiking_outdoor.sport': 'Vaellus',
    'double_board_skiing.sport': 'Hiihto',
    'run_indoor.sport': 'Juoksumatto',
    'climbing.sport': 'Retkeily',
    'walk_outdoor.sport': 'Kävely',
    'snowboarding.sport': 'Lumilautailu',
    'swim_outdoor.sport': 'Avovesiuinti',
    'fishing.sport': 'Kalastus',
    'sailboat.sport': 'Purjehdus',
    'paddle_board.sport': 'Melonta',
    'water_polo.sport': 'Vesipallo',
    'water_sports.sport': 'Vesiurheilu',
    'surfing.sport': 'Vesihiihto',
    'canoeing.sport': 'Kajakointi',
    'kayak_rafting.sport': 'Koskenlasku',
    'rowing.sport': 'Soutu',
    'motorboat.sport': 'Moottoriveneily',
    'web_swimming.sport': 'Räpyläuinti'
  },
  in_ID: {
    'ride_outdoor.sport': 'Sepeda outdoor',
    'outdoor_sports.sport': 'Lari outdoor',
    'cross_country.sport': 'Lari lintas alam',
    'swim_indoor.sport': 'Berenang di kolam',
    'hiking_outdoor.sport': 'Mendaki',
    'double_board_skiing.sport': 'Ski',
    'run_indoor.sport': 'Treadmill',
    'climbing.sport': 'Trekking',
    'walk_outdoor.sport': 'Jalan kaki',
    'snowboarding.sport': 'Seluncur salju',
    'swim_outdoor.sport': 'Perairan terbuka',
    'fishing.sport': 'Memancing',
    'sailboat.sport': 'Berlayar',
    'paddle_board.sport': 'Paddleboarding',
    'water_polo.sport': 'Polo air',
    'water_sports.sport': 'Olahraga air',
    'surfing.sport': 'Ski air',
    'canoeing.sport': 'Kayak',
    'kayak_rafting.sport': 'Arung jeram',
    'rowing.sport': 'Dayung (Rower)',
    'motorboat.sport': 'Motor boat',
    'web_swimming.sport': 'Finswimming'
  },
  el_GR: {
    'ride_outdoor.sport': 'Υπαίθρια ποδηλασία',
    'outdoor_sports.sport': 'Υπαίθριο τρέξιμο',
    'cross_country.sport': 'Τρέξιμο ανώμαλου δρόμου',
    'swim_indoor.sport': 'Κολύμβηση σε πισίνα',
    'hiking_outdoor.sport': 'Ορειβασία',
    'double_board_skiing.sport': 'Σκι',
    'run_indoor.sport': 'Διάδρομος',
    'climbing.sport': 'Πεζοπορία',
    'walk_outdoor.sport': 'Περπάτημα',
    'snowboarding.sport': 'Σνόουμπορντ',
    'swim_outdoor.sport': 'Ανοικτά νερά',
    'fishing.sport': 'Ψάρεμα',
    'sailboat.sport': 'Ιστιοπλοΐα',
    'paddle_board.sport': 'Σανίδα κωπηλασίας',
    'water_polo.sport': 'Υδατοσφαίριση',
    'water_sports.sport': 'Αθλήματα νερού',
    'surfing.sport': 'Θαλάσσιο σκι',
    'canoeing.sport': 'Καγιάκ',
    'kayak_rafting.sport': 'Ράφτινγκ',
    'rowing.sport': 'Κωπηλασία',
    'motorboat.sport': 'Ταχυπλοΐα',
    'web_swimming.sport': 'Τεχνητή κολύμβηση'
  },
  ro_RO: {
    'ride_outdoor.sport': 'Ciclism în aer liber',
    'outdoor_sports.sport': 'Alergare în aer liber',
    'cross_country.sport': 'Pistă de alergare',
    'swim_indoor.sport': 'Înot piscină',
    'hiking_outdoor.sport': 'Drumeție',
    'double_board_skiing.sport': 'Schi',
    'run_indoor.sport': 'Bandă de alergare',
    'climbing.sport': 'Drumeție montană',
    'walk_outdoor.sport': 'Mers',
    'snowboarding.sport': 'Snowboarding',
    'swim_outdoor.sport': 'Înot în aer liber',
    'fishing.sport': 'Pescuit',
    'sailboat.sport': 'Navigație',
    'paddle_board.sport': 'Paddleboarding',
    'water_polo.sport': 'Polo pe apă',
    'water_sports.sport': 'Sporturi acvatice',
    'surfing.sport': 'Schi nautic',
    'canoeing.sport': 'Caiac',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Aparat de vâslit',
    'motorboat.sport': 'Barcă cu motor',
    'web_swimming.sport': 'Înot cu labele'
  },
  cs_CZ: {
    'ride_outdoor.sport': 'Jízda na kole',
    'outdoor_sports.sport': 'Venkovní běh',
    'cross_country.sport': 'Terénní běh',
    'swim_indoor.sport': 'Plavání v bazénu',
    'hiking_outdoor.sport': 'Pěší turistika',
    'double_board_skiing.sport': 'Lyžování',
    'run_indoor.sport': 'Běžecký pás',
    'climbing.sport': 'Treking',
    'walk_outdoor.sport': 'Chůze',
    'snowboarding.sport': 'Snowboarding',
    'swim_outdoor.sport': 'Otevřená voda',
    'fishing.sport': 'Rybaření',
    'sailboat.sport': 'Plachtění',
    'paddle_board.sport': 'Paddleboarding',
    'water_polo.sport': 'Vodní pólo',
    'water_sports.sport': 'Vodní sporty',
    'surfing.sport': 'Vodní lyžování',
    'canoeing.sport': 'Jízda na kajaku',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Veslování',
    'motorboat.sport': 'Motorový člun',
    'web_swimming.sport': 'Ploutvové plavání'
  },
  uk_UA: {
    'ride_outdoor.sport': 'Їзда на велосипеді на вулиці',
    'outdoor_sports.sport': 'Біг на вулиці',
    'cross_country.sport': 'Трейлраннінг',
    'swim_indoor.sport': 'Плавання у басейні',
    'hiking_outdoor.sport': 'Хайкінг',
    'double_board_skiing.sport': 'Лижі',
    'run_indoor.sport': 'Бігова доріжка',
    'climbing.sport': 'Трекінг',
    'walk_outdoor.sport': 'Ходьба',
    'snowboarding.sport': 'Сноуборд',
    'swim_outdoor.sport': 'Плавання у відкритій воді',
    'fishing.sport': 'Риболовля',
    'sailboat.sport': 'Вітрильний спорт',
    'paddle_board.sport': 'Паддлбордінг',
    'water_polo.sport': 'Водне поло',
    'water_sports.sport': 'Інші водні види спорту',
    'surfing.sport': 'Водні лижі',
    'canoeing.sport': 'Каякінг',
    'kayak_rafting.sport': 'Рафтинг',
    'rowing.sport': 'Гребні види спорту',
    'motorboat.sport': 'Водно-моторні види спорту',
    'web_swimming.sport': 'Плавання в ластах'
  },
  sk_SK: {
    'ride_outdoor.sport': 'Cyklistika',
    'outdoor_sports.sport': 'Beh v prírode',
    'cross_country.sport': 'Beh v prírode',
    'swim_indoor.sport': 'Plávanie v bazéne',
    'hiking_outdoor.sport': 'Turistika',
    'double_board_skiing.sport': 'Lyžovanie',
    'run_indoor.sport': 'Bežecký pás',
    'climbing.sport': 'Turistika',
    'walk_outdoor.sport': 'Chôdza',
    'snowboarding.sport': 'Snowboarding',
    'swim_outdoor.sport': 'Otvorená voda',
    'fishing.sport': 'Rybolov',
    'sailboat.sport': 'Plachtenie',
    'paddle_board.sport': 'Paddleboarding',
    'water_polo.sport': 'Vodné pólo',
    'water_sports.sport': 'Ostatné vodné športy',
    'surfing.sport': 'Vodné lyžovanie',
    'canoeing.sport': 'Kajaking',
    'kayak_rafting.sport': 'Rafting',
    'rowing.sport': 'Veslovanie',
    'motorboat.sport': 'Motorový čln',
    'web_swimming.sport': 'Plávanie s plutvami'
  },
  hu_HU: {
    'ride_outdoor.sport': 'Szabadtéri kerékpározás',
    'outdoor_sports.sport': 'Szabadtéri futás',
    'cross_country.sport': 'Terepfutás',
    'swim_indoor.sport': 'Úszás medencében',
    'hiking_outdoor.sport': 'Túrázás',
    'double_board_skiing.sport': 'Síelés',
    'run_indoor.sport': 'Futópad',
    'climbing.sport': 'Hegymászás',
    'walk_outdoor.sport': 'Gyaloglás',
    'snowboarding.sport': 'Snoawboardozás',
    'swim_outdoor.sport': 'Nyílt víz',
    'fishing.sport': 'Horgászat',
    'sailboat.sport': 'Vitorlázás',
    'paddle_board.sport': 'Evezős szörfölés',
    'water_polo.sport': 'Vízilabda',
    'water_sports.sport': 'Vízisportok',
    'surfing.sport': 'Vízisíelés',
    'canoeing.sport': 'Kajakozás',
    'kayak_rafting.sport': 'Vadvízi evezés',
    'rowing.sport': 'Evezés',
    'motorboat.sport': 'Hajózás',
    'web_swimming.sport': 'Uszonyos úszás'
  },
  ar_EG: {
    'ride_outdoor.sport': 'ركوب الدراجات بالخارج',
    'outdoor_sports.sport': 'الجري بالخارج',
    'cross_country.sport': 'الجري بالطبيعة',
    'swim_indoor.sport': 'سباحة في المسبح',
    'hiking_outdoor.sport': 'المشي الجبلي',
    'double_board_skiing.sport': 'التزحلق',
    'run_indoor.sport': 'جهاز المشي',
    'climbing.sport': 'تسلق الجبال',
    'walk_outdoor.sport': 'المشي',
    'snowboarding.sport': 'التزلج على الجليد',
    'swim_outdoor.sport': 'مياه مفتوحة',
    'fishing.sport': 'صيد السمك',
    'sailboat.sport': 'الإبحار',
    'paddle_board.sport': 'تجديف على الألواح',
    'water_polo.sport': 'كرة الماء',
    'water_sports.sport': 'رياضات مائية',
    'surfing.sport': 'تزلج على الماء',
    'canoeing.sport': 'تجديف بالكاياك',
    'kayak_rafting.sport': 'تجديف بالزورق',
    'rowing.sport': 'تجديف بالقوارب',
    'motorboat.sport': 'زورق سريع',
    'web_swimming.sport': 'سباحة بالزعانف'
  },
  iw_IL: {
    'ride_outdoor.sport': 'רכיבת אופניים בחוץ',
    'outdoor_sports.sport': 'ריצה בחוץ',
    'cross_country.sport': 'ריצה בשטח',
    'swim_indoor.sport': 'שחייה בבריכה',
    'hiking_outdoor.sport': 'צעדה רגלית',
    'double_board_skiing.sport': 'סקי',
    'run_indoor.sport': 'מסילת כושר',
    'climbing.sport': 'טיול רגלי בשטח',
    'walk_outdoor.sport': 'הליכה',
    'snowboarding.sport': 'גלישת שלג',
    'swim_outdoor.sport': 'מים פתוחים',
    'fishing.sport': 'דיג',
    'sailboat.sport': 'שייט',
    'paddle_board.sport': 'גלישה עם משוט',
    'water_polo.sport': 'פולו מים',
    'water_sports.sport': 'ספורט מים',
    'surfing.sport': 'סקי מים',
    'canoeing.sport': 'קיאקים',
    'kayak_rafting.sport': 'ראפטינג',
    'rowing.sport': 'חתירה',
    'motorboat.sport': 'סירת מנוע',
    'web_swimming.sport': 'שחייה מתחת למים'
  },
  zh_HK: {
    'ride_outdoor.sport': '戶外騎行',
    'outdoor_sports.sport': '戶外跑步',
    'cross_country.sport': '越野',
    'swim_indoor.sport': '泳池游泳',
    'hiking_outdoor.sport': '徒步',
    'double_board_skiing.sport': '雙板滑雪',
    'run_indoor.sport': '室內跑步',
    'climbing.sport': '登山',
    'walk_outdoor.sport': '健走',
    'snowboarding.sport': '單板滑雪',
    'swim_outdoor.sport': '開放水域游泳',
    'fishing.sport': '釣魚',
    'sailboat.sport': '帆船',
    'paddle_board.sport': '槳板',
    'water_polo.sport': '水球',
    'water_sports.sport': '水上運動',
    'surfing.sport': '滑水',
    'canoeing.sport': '皮划艇',
    'kayak_rafting.sport': '皮艇漂流',
    'rowing.sport': '划船',
    'motorboat.sport': '水上電單車',
    'web_swimming.sport': '蹼泳',
    'track_running.sport': '操場跑步'
  },
  lt_LT: {
    'ride_outdoor.sport': 'Dviračių sportas lauke',
    'outdoor_sports.sport': 'Bėgiojimas lauke',
    'cross_country.sport': 'Bėgimas trasomis',
    'swim_indoor.sport': 'Plaukimas baseine',
    'hiking_outdoor.sport': 'Žygiai',
    'double_board_skiing.sport': 'Slidinėjimas',
    'run_indoor.sport': 'Bėgimo takelis',
    'climbing.sport': 'Žygiavimas',
    'walk_outdoor.sport': 'Vaikščiojimas',
    'snowboarding.sport': 'Snieglenčių sportas',
    'swim_outdoor.sport': 'Plaukimas atvirame vandenyje',
    'fishing.sport': 'Žvejyba',
    'sailboat.sport': 'Buriavimas',
    'paddle_board.sport': 'Irklentės',
    'water_polo.sport': 'Vandensvydis',
    'water_sports.sport': 'Kiti vandens sportai',
    'surfing.sport': 'Vandens slidės',
    'canoeing.sport': 'Plaukimas baidarėmis',
    'kayak_rafting.sport': 'Plaukimas plaustais',
    'rowing.sport': 'Irklavimas',
    'motorboat.sport': 'Plaukimas motorizuota valtimi',
    'web_swimming.sport': 'Plaukimas su pelekais'
  },
  bg_BG: {
    'ride_outdoor.sport': 'Колоездене на открито',
    'outdoor_sports.sport': 'Бягане на открито',
    'cross_country.sport': 'Бягане в пресечена местност',
    'swim_indoor.sport': 'Плуване в басейн',
    'hiking_outdoor.sport': 'Преходи',
    'double_board_skiing.sport': 'Каране на ски',
    'run_indoor.sport': 'Бягаща пътека',
    'climbing.sport': 'Трекинг',
    'walk_outdoor.sport': 'Ходене',
    'snowboarding.sport': 'Сноубординг',
    'swim_outdoor.sport': 'Открити води',
    'fishing.sport': 'Риболов',
    'sailboat.sport': 'Ветроходство',
    'paddle_board.sport': 'Плаване с гребло',
    'water_polo.sport': 'Водно поло',
    'water_sports.sport': 'Други водни спортове',
    'surfing.sport': 'Водни ски',
    'canoeing.sport': 'Плаване с каяк',
    'kayak_rafting.sport': 'Рафтинг',
    'rowing.sport': 'Гребане',
    'motorboat.sport': 'Моторни лодки',
    'web_swimming.sport': 'Плаване с плавник'
  }
};
